import React, {Component} from 'react';
import styled from 'styled-components';
import {brk} from "../styles/constants";
import {StaticQuery, graphql} from "gatsby";
import ImageTyped from "./ImageTyped";


const Container = styled.div`
    display: block;
    width: 100%;
    height : 700px;
    max-height : 700px;
    background : black;
    overflow : hidden;
    
    
    
    @media (min-width: ${brk.L}) {
        max-height : 800px;

        img{
          width : 100% !important;
          height : auto !important;
          height  : auto;
          max-height : inherit;
        }
      }
    
    @media (min-width : ${brk.S}) and (max-width: ${brk.L}) {
        max-height : 60vw;

        img{
          width : 100% !important;
          height : auto !important;
          height  : auto;
          max-height : inherit;
        }
      }
    
    @media (max-width : ${brk.S}){
        height : 400px;
        max-height : 100vw;

        img{
          width : 100% !important;
          height : auto !important;
          height  : auto;
          max-height : inherit;
        }
    }
`;

const BackgroundImage = styled.div`
    width: 100%;
    height: 100%;
	min-height: 600px;
	max-height : 60vw;
	position: relative;
	display: flex;
	background-position : center !important;
	background-size: cover !important;
	//background-attachment: fixed !important;
    justify-content : center;
    align-items : flex-end;
    
    @media (max-width : ${brk.S}){
        min-height: 400px;
        max-height : 400px;
        height : 400px;
        background-size:auto 500px !important;
        background-position : top !important;
    }
	


`;
const Mouse = styled.div`
    width: 50px;
    height: 50px;
    margin-bottom:20px;
    border-radius:100%;
    overflow : hidden;

`;



class ImageHeader extends Component {
    render() {
        const {
            image,
            mouse
        } = this.props;


        return (
            <Container >
                <BackgroundImage  style={{ backgroundImage: `url(${image.fluid.src})`}}
                >
                    <Mouse>
                        <ImageTyped dataImage={mouse}/>
                    </Mouse>
                </BackgroundImage>
            </Container>
        )
    }
}



export default ({image}) => (
    <StaticQuery
        query={graphql`
          query headerQuery {
            mouse: allContentfulAsset(filter: {title: {eq: "Souris"}}) {
                edges {
                  node {
                    id
                    id
                    file {
                      url
                      fileName
                      contentType
                    }
                    fluid(maxWidth: 300) {
                      sizes
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                    }
                  }
                }
              }
          }
        `}
        render={data => (
            <ImageHeader image={image} mouse={data.mouse.edges[0].node}/>
        )}
    />
)